import React from "react";

function PricingSectionShimmer() {
  return (
    <div className="flex flex-col flex-1 lg:max-w-md border-2 border-gray-300 bg-white top-4 sticky p-2 sm:p-4 h-fit rounded-lg">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4 mb-3">
        <div className="w-full lg:w-24 h-56 sm:h-96 lg:h-20 shimmer rounded-lg object-cover"></div>

        <span className="text-xl rounded-full w-[50%] h-5 shimmer"></span>
      </div>
      {["", ""]?.map((_, index) => (
        <div className="flex items-center gap-2 text-gray-500 mb-2" key={index}>
          <div alt="" className="w-4 shimmer h-4 object-contain rounded-full">
            {" "}
          </div>

          <span className="w-[80%] shimmer h-3 rounded-full"></span>
        </div>
      ))}
      <></>
      <div className="flex w-full justify-between text-sm pb-2 border-b-2 border-b-400 mb-4 mt-4">
        <span className="w-[30%] shimmer h-5 rounded-full"></span>
      </div>
      {["", ""]?.map((_, index) => (
        <div
          className="text-lg flex w-full justify-between text-gray-700 mb-2"
          key={index}
        >
          {/* <span>name</span> */}
          <span className="w-[30%] shimmer h-4 rounded-full"></span>
          <span className="w-[30%] shimmer h-4 rounded-full"></span>
        </div>
      ))}
      <div className="font-bold text-lg flex w-full justify-between pb-2 pt-3 border-t-2 border-b-400 mb-4 mt-4">
        <span className="w-[30%] shimmer h-5 rounded-full"></span>
        <span className="w-[30%] shimmer h-5 rounded-full"></span>
      </div>
      <div className="flex shimmer bg-blue-600/10 rounded-md h-14 w-full py-4 px-4 flex-col mb-2"></div>
    </div>
  );
}

export default PricingSectionShimmer;
